export const FILTERS = {
  FILTERS_TERRITORIES_LABEL: 'COMMON_SEARCH_FILTERS_TERRITORIES_LABEL',
  FILTERS_THEMATICS_LABEL: 'COMMON_SEARCH_FILTERS_THEMATICS_LABEL',
  FILTERS_TYPES_LABEL: 'COMMON_SEARCH_FILTERS_TYPES_LABEL',
  NEWSROOM_FILTER_TITLE: 'COMMON_SEARCH_NEWSROOM_FILTER_TITLE',
  TERRITORIES_REGIONS: 'COMMON_SEARCH_TERRITORIES_REGIONS',
  TERRITORIES_WORLD: 'COMMON_SEARCH_TERRITORIES_WORLD',
  FILTER_PERIODS_LABEL: 'COMMON_SEARCH_FILTER_PERIODS_LABEL',
  FILTER_SELECTED: 'COMMON_SEARCH_FILTER_SELECTED',
  FILTER_SELECTED_plural: 'COMMON_SEARCH_FILTERS_SELECTED',
  FILTER_STICKY_LABEL: 'COMMON_SEARCH_FILTER_STICKY_LABEL',
  FILTERS_EXPERTISES_LABEL: 'COMMON_SEARCH_FILTERS_EXPERTISES_LABEL',
  RESULT_COUNT: 'COMMON_SEARCH_RESULT_COUNT',
  RESULT_COUNT_plural: 'COMMON_SEARCH_RESULTS_COUNT',

  COMMON_DOCUMENTS: 'FILTERS_COMMON_DOCUMENTS',
  COMMON_FILTER_APPLY: 'FILTERS_COMMON_FILTER_APPLY',
  COMMON_FORMATS: 'FILTERS_COMMON_FORMATS',
  COMMON_PUBLICATION_DATE: 'FILTERS_COMMON_PUBLICATION_DATE',
  COMMON_REGION: 'FILTERS_COMMON_REGION',
  COMMON_THEMATICS: 'FILTERS_COMMON_THEMATICS',
  COMMON_START_DATE: 'FILTERS_COMMON_START_DATE',
  COMMON_END_DATE: 'FILTERS_COMMON_END_DATE',
  COMMON_ACTIVE_FILTERS: 'FILTERS_COMMON_ACTIVE_FILTERS',
  COMMON_RESET: 'FILTERS_COMMON_RESET',
  COMMON_FILTER_CLOSE: 'FILTERS_COMMON_FILTER_CLOSE',
  COMMON_FILTER_NEWS: 'FILTERS_COMMON_FILTER_NEWS',
  COMMON_FILTER: 'FILTERS_COMMON_FILTER',
  INVESTORS_PRESS_RELEASE_THEMES:
    'FILTERS_INVESTORS_PRESS_RELEASE_THEMES_TITLE',
  INVESTORS_PRESS_RELEASE_YEARS: 'FILTERS_INVESTORS_PRESS_RELEASE_YEARS_TITLE',
  INVESTORS_PRESS_RELEASE_MONTHS:
    'FILTERS_INVESTORS_PRESS_RELEASE_MONTHS_TITLE',
};
